import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import WCLogoComplete from '../../assets/images/wc-logo-complete';
import WCLogo from '../../assets/images/wc-logo';
import { ResetUser } from '../auth/store/actions';
import { clearKpiState } from '../kpi/store/actions';
import './assets/styles/NavBar.scss';

const NavBar = () => {
  const auth = useSelector((state) => state.auth);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const signout = () => {
    dispatch(ResetUser({}));
    navigate('/auth');
  };

  let title = 'Dashboard';

  // if (window.location.pathname === '/audio-books-allocation') {
  //   title = 'Audiobooks Allocation';
  // } else if (window.location.pathname === '/campaign-and-channels') {
  //   title = 'Campaign & Channels';
  // } else if (window.location.pathname === '/kpi-dump') {
  //   title = 'Download Dump';
  // }

  const clearCache = () => {
    dispatch(clearKpiState());
    navigate('/');
  }

  return (
    <div className='navbar nav-bar sticky-top navbar-light bg-light'>
      <div className='nav-bar--container'>
        <div className='nav-bar--images'>
          <div className='d-none d-sm-block'>
            <WCLogoComplete />
          </div>
          <div className='d-block d-sm-none'>
            <WCLogo />
          </div>
          <span className='nav-bar--images--title'>{title}</span>
        </div>
        <div className='nav-bar--actions'>
          {/* <button className='btn btn-danger ms-3' onClick={clearCache} style={{ whiteSpace: 'pre' }}>Clear cache</button> */}
          <div className='nav-bar--actions--current-user'>{auth?.data?.name}</div>
          <a onClick={signout}>Sign Out</a>
        </div>
      </div>
    </div>
  );
};

export default NavBar;
